"use strict";

exports.__esModule = true;
exports.default = debounce;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _now = _interopRequireDefault(require("./now.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, previous, args, result, context;
  var _later = function later() {
    var passed = (0, _now.default)() - previous;
    if (wait > passed) {
      timeout = setTimeout(_later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
      // This check is needed because `func` can recursively invoke `debounced`.
      if (!timeout) args = context = null;
    }
  };
  var debounced = (0, _restArguments.default)(function (_args) {
    context = this;
    args = _args;
    previous = (0, _now.default)();
    if (!timeout) {
      timeout = setTimeout(_later, wait);
      if (immediate) result = func.apply(context, args);
    }
    return result;
  });
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = args = context = null;
  };
  return debounced;
}